import {
  USER_GET_DATA,
  USER_GET_DATA_SUCCESS,
  USER_GET_DATA_ERROR,
  USER_EDIT_ITEM,
  USER_EDIT_ITEM_SUCCESS,
  USER_EDIT_ITEM_ERROR,
  USER_GET_AVATAR,
  USER_GET_AVATAR_SUCCESS,
  USER_GET_AVATAR_ERROR,
  USER_AVATAR_EDIT_ITEM,
  USER_AVATAR_EDIT_ITEM_SUCCESS,
  USER_AVATAR_EDIT_ITEM_ERROR,
  USER_REMOVE_ITEM,
  USER_REMOVE_ITEM_SUCCESS,
  USER_REMOVE_ITEM_ERROR,
  USER_VALIDATE_ITEM,
  USER_VALIDATE_ITEM_SUCCESS,
  USER_VALIDATE_ITEM_ERROR,
  USER_ADMIN_EDIT_ITEM,
  USER_ADMIN_EDIT_ITEM_SUCCESS,
  USER_ADMIN_EDIT_ITEM_ERROR,
  USER_CLEAR_DATA,
} from "../actions";

const INIT_STATE = {
  loading: false,
  data: null,
  avatar: null,
  editItem: null,
  editAvatar: null,
  validateItem: null,
  manageAdminItem: null,
  removeItem: null,
  error: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    //* GET DATA LOGGED USER  -----------------------------------------------------------------------------

    case USER_GET_DATA:
      //console.log("inside reducer");
      return { ...state, loading: true, error: null };

    case USER_GET_DATA_SUCCESS:
      // console.log(action.payload);

      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case USER_GET_DATA_ERROR:
      //console.log(action.payload);
      return { ...state, loading: false, error: action.payload };

    //* EDIT LOGGED USER ---------------------------------------------------------------------------------

    case USER_EDIT_ITEM:
      return { ...state, loading: true, error: "" };

    case USER_EDIT_ITEM_SUCCESS:
      // console.log("success", action.payload);
      return {
        ...state,
        loading: false,
        editItem: action.payload,
        error: "",
      };

    case USER_EDIT_ITEM_ERROR:
      return {
        ...state,
        loading: false,
        editItem: null,
        error: action.payload,
      };

    //* GET AVATAR LOGGED USER  ---------------------------------------------------------------------------
    case USER_GET_AVATAR:
      // console.log("inside reducer get avatar");
      return { ...state, loading: true, error: "" };

    case USER_GET_AVATAR_SUCCESS:
      //console.log("avatar get success", action.payload);
      return {
        ...state,
        loading: false,
        avatar: action.payload,
        error: "",
      };

    case USER_GET_AVATAR_ERROR:
      return {
        ...state,
        loading: false,
        // avatar: "",
        error: action.payload,
      };

    //* EDIT AVATAR LOGGED USER   -----------------------------------------------------------------------------

    case USER_AVATAR_EDIT_ITEM:
      // console.log("inside reducer add avatar");
      return { ...state, loading: true, error: "" };

    case USER_AVATAR_EDIT_ITEM_SUCCESS:
      // console.log("avatar add success", action.payload);
      return {
        ...state,
        loading: false,
        editAvatar: action.payload,
        error: "",
      };

    case USER_AVATAR_EDIT_ITEM_ERROR:
      return {
        ...state,
        loading: false,
        editAvatar: null,
        error: action.payload,
      };

    //* REMOVE USER // ---------------------------------------------------------------------------------------------
    case USER_REMOVE_ITEM:
      return { ...state, loading: true, error: "" };

    case USER_REMOVE_ITEM_SUCCESS:
      console.log("USER_REMOVE_ITEM_SUCCES", action.payload);
      return {
        ...state,
        loading: false,
        removeItem: action.payload,
        error: "",
      };

    case USER_REMOVE_ITEM_ERROR:
      return {
        ...state,
        loading: false,
        removeItem: null,
        error: action.payload,
      };

    //* VALIDATE USER (SUPER ADMIN)// ---------------------------------------------------------------------------------------------

    case USER_VALIDATE_ITEM:
      return { ...state, loading: true, error: "" };

    case USER_VALIDATE_ITEM_SUCCESS:
      console.log("USER_VALIDATE_ITEM_SUCCES", action.payload);
      return {
        ...state,
        loading: false,
        validateItem: action.payload,
        error: "",
      };

    case USER_VALIDATE_ITEM_ERROR:
      return {
        ...state,
        loading: false,
        validateItem: null,
        error: action.payload,
      };

    //* EDIT ADMIN USER (promoting to admin and edit managed user) (SUPER ADMIN)  ---------------------------------------------------------------------------------

    case USER_ADMIN_EDIT_ITEM:
      return { ...state, loading: true, error: "" };

    case USER_ADMIN_EDIT_ITEM_SUCCESS:
      console.log("success", action.payload);
      return {
        ...state,
        loading: false,
        manageAdminItem: action.payload,
        error: "",
      };

    case USER_ADMIN_EDIT_ITEM_ERROR:
      return {
        ...state,
        loading: false,
        manageAdminItem: null,
        error: action.payload,
      };

    //* CLEAR DATA LOGGED USER // ---------------------------------------------------------------------------------------------

    case USER_CLEAR_DATA:
      return {
        ...INIT_STATE,
      };

    default:
      return { ...state };
  }
};
